import { useQuery, UseQueryResult } from 'react-query';
import { Offer } from '../../../../types/Offer';
import { wgApi } from '../../../app/src/features/api/wgApi';
import { useDistribution } from '../../../app/src/features/authentication/api/get/getDistribution';

const getOffersByPartyId = async (
  distributionId: string,
  partyId: string,
): Promise<Offer[]> => {
  const path = `v1/api/broker/v1/api/distributions/${distributionId}/offers?prospect_id=${partyId}`;
  const { data, isError } = await wgApi.get<{ items: Offer[] }>(path);
  if (isError) throw new Error();
  return data.items;
};

export const getUsePartyOffersQKey = (partyId?: string) => [
  'party',
  'offers',
  partyId,
];

export const usePartyOffers = (partyId: string): UseQueryResult<Offer[]> => {
  const { data } = useDistribution();
  return useQuery<Offer[]>(
    getUsePartyOffersQKey(partyId),
    () => getOffersByPartyId(data!.id, partyId),
    {
      refetchOnWindowFocus: false,
      enabled: !!partyId,
    },
  );
};
